import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Divider } from '_zari/core'

import * as Forms from './forms'

import * as AuthService from 'services/auth.service'

const CompaniaLogoSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const [edicionData, setEdicionData] = React.useState(null)

  React.useEffect(() => {
    AuthService.obtenerCompaniaLogoEdicion()
      .then(({ data }) => {
        setEdicionData(data || {})
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Logos' />
      <Portlet.Body>{edicionData && <Forms.ExternoForm edicionData={edicionData.externo} />}</Portlet.Body>
      <Divider/>
      <Portlet.Body>{edicionData && <Forms.ImpresionForm edicionData={edicionData.impresion} />}</Portlet.Body>
    </Portlet>
  )
}

export default React.memo(CompaniaLogoSection)
